import { Box } from "@mui/material";

export const quizQuestions = [
    {
        id: 1,
        question: "About how many new NC items were added to our database in this past year?",
        correctAnswer: "c",
        explanation:
            "isn't it crazy how many tradeable items have been released in just a year?",
        options: [
            {
                id: "a",
                name: "1,000",
            },
            {
                id: "b",
                name: "2,500",
            },
            {
                id: "c",
                name: "3,500",
            },
            {
                id: "d",
                name: "2,700",
            }
        ]
    },
    {
        id: 2,
        question: "What was the most traded wearable item in reports?",
        correctAnswer: "a",
        explanation:
            "we got over 200 reports that involved an angelic haze filter!",
        options: [
            {
                id: "a",
                name: "Angelic Haze Filter",
                image: "https://images.neopets.com/items/edcgl5kgga.gif"
            },
            {
                id: "b",
                name: "MME30-S5a: Dreamland Sparkle Filter",
                image: "https://images.neopets.com/items/bc2n31c8he.gif"
            },
            {
                id: "c",
                name: "Extra Glitter Filter",
                image: "https://images.neopets.com/items/bai0hgd23h.gif"
            },
            {
                id: "d",
                name: "Ethereal Flower Field Background",
                image: "https://images.neopets.com/items/bd5gck3a28.gif"
            }
        ]
    },
    {
        id: 3,
        question: "About how many BFGBCs were traded in the past year in reports?",
        correctAnswer: "c",
        explanation: "and somehow we still have a box drought . . .",
        options: [
            {
                id: "a",
                name: "127",
            },
            {
                id: "b",
                name: "2,800",
            },
            {
                id: "c",
                name: "6,500",
            },
            {
                id: "d",
                name: "2,200",
            }
        ]
    },
    {
        id: 4,
        question: "What is the most traded token in reports? (excluding prismatics/essences)",
        correctAnswer: "b",
        explanation:
            "seems that there's a soft spot for plushie babies?",
        options: [
            {
                id: "a",
                name: "Valentine Plushie Aisha",
                image: "https://images.neopets.com/items/valentine_plushie_aisha.gif"
            },
            {
                id: "b",
                name: "Plushie Baby Cybunny",
                image: "https://images.neopets.com/items/plushie_baby_cybunny.gif"
            },
            {
                id: "c",
                name: "Nostalgic Faerie Xweetok",
                image: "https://images.neopets.com/items/nostalgic_faerie_xweetok.gif"
            },
            {
                id: "d",
                name: "Somber Grey Kacheek",
                image: "https://images.neopets.com/items/5a5f3td3.gif"
            }
        ]
    },
    {
        id: 5,
        question: "What is the most traded prismatic token in reports?",
        correctAnswer: "b",
        explanation:
            "prismatic peony (not an option) was actually 2nd place so i guess y'all really love prismatic unis",
        options: [
            {
                id: "a",
                name: "Habbo Hotel Pastel Kacheek",
                image: "https://images.neopets.com/items/4qp9sma2.gif"
            },
            {
                id: "b",
                name: "Prismatic Wisteria: Blooming Woodland Uni",
                image: "https://images.neopets.com/items/3qbp1ib7b.gif"
            },
            {
                id: "c",
                name: "Prismatic Pink: Nostalgic Faerie Aisha",
                image: "https://images.neopets.com/items/4566che56m.gif"
            },
            {
                id: "d",
                name: "Prismatic Lunar: Ethereal Void Varwolf",
                image: "https://images.neopets.com/items/25915lhql.gif"
            }
        ]
    },
    {
        id: 6,
        question: "About how many reports did we receive this past year?",
        correctAnswer: "d",
        explanation: "we've received and processed 16300+ reports just in this past year!",
        options: [
            {
                id: "a",
                name: "10,700",
            },
            {
                id: "b",
                name: "8,800",
            },
            {
                id: "c",
                name: "19,600",
            },
            {
                id: "d",
                name: "16,300",
            }
        ]
    },
    {
        id: 7,
        question: "About how many board reports did we input into our system?",
        correctAnswer: "a",
        explanation: "major shoutout to nina for doing almost all of them!",
        options: [
            {
                id: "a",
                name: "600",
            },
            {
                id: "b",
                name: "200",
            },
            {
                id: "c",
                name: "450",
            },
            {
                id: "d",
                name: "500",
            }
        ]
    },
    {
        id: 8,
        question: "What is the most traded in reports out of these items?",
        correctAnswer: "b",
        explanation: "90% of gamblers quit before they hit it big amirite",
        options: [
            {
                id: "a",
                name: "Dyeworks Hue Brew Potion",
                image: "https://images.neopets.com/items/mall_80x80_cleaning.gif"
            },
            {
                id: "b",
                name: "Styling Studio Supplies",
                image: "https://images.neopets.com/items/mall_ss_supplies.gif"
            },
            {
                id: "c",
                name: "Styling Studio Prismatic Brush",
                image: "https://images.neopets.com/items/h2bb8ihj4c.gif"
            },
            {
                id: "d",
                name: "NC Upcycle Fortune Cookie",
                image: "https://images.neopets.com/items/mall_fc_trading.gif"
            }
        ]
    },
    {
        id: 9,
        question: "What is our team's #1 annoyance with TNT?",
        correctAnswer: "d",
        explanation: "i promise u we have the items in our db but tnt just randomly changes them idk why",
        options: [
            {
                id: "a",
                name: "they release too many items",
            },
            {
                id: "b",
                name: "nc mall broken too much",
            },
            {
                id: "c",
                name: "rereleases go brrrrrrr",
            },
            {
                id: "d",
                name: "they change item names randomly",
            }
        ]
    },
    {
        id: 10,
        question: <>
            QUICK WITHOUT CHECKING WHAT'S THE DYEWORKS GUY'S NAME
            <Box sx={{ textAlign: "center" }}>
                {/* eslint-disable-next-line */}
                <img src="https://images.neopets.com/ncmall/ui/assets/specialty-dyeworks-icon-DEq_zlYR.png" alt="dyeworks" style={{ maxWidth: "50%", borderRadius: 8, marginBottom: 10 }} />
            </Box>
        </>,
        correctAnswer: "a",
        explanation: "i just put this question here for fun bc i love dyeworks",
        options: [
            {
                id: "a",
                name: "loic",
            },
            {
                id: "b",
                name: "cornelius",
            },
            {
                id: "c",
                name: "larry",
            },
            {
                id: "d",
                name: "raine",
            }
        ]
    },
];

export const resultTiers = [
    {
        minScore: 0,
        maxScore: 2,
        title: "i can tell u touch grass",
        image: "https://images.neopets.com/games/new_tradingcards/lg_raindorf_day_2005.gif",
        description: "how it must feel to be free from nc"
    },

    {
        minScore: 3,
        maxScore: 5,
        title: "that's rough buddy",
        image: "https://images.neopets.com/games/new_tradingcards/lg_library_snot.gif",
        description: "were u surprised by the actual answers in a good way (pls say yes)"
    },

    {
        minScore: 6,
        maxScore: 8,
        title: "not bad at all!",
        image: "https://images.neopets.com/games/new_tradingcards/lg_tea.gif",
        description: "i would tell u that ur above average but idk what the average is"
    },
    {
        minScore: 9,
        maxScore: 9,
        title: "ooo you love nc",
        image: "https://images.neopets.com/games/new_tradingcards/lg_1.gif",
        description: "you were in the zoneeeee for this quiz"
    },
    {
        minScore: 10,
        maxScore: 10,
        title: "GOAT",
        image: "https://images.neopets.com/games/new_tradingcards/lg_coltzan_2006.gif",
        description:
            "YOU KNOW NC BALL FR"
    }
];